var _g;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgIconWhatsapp = function SvgIconWhatsapp(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30.135,
    viewBox: "0 0 30 30.135",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Grupo_2068",
    "data-name": "Grupo 2068",
    transform: "translate(-4.812 -0.43)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "logo",
    transform: "translate(4.812 0.43)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_2070",
    "data-name": "Grupo 2070",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_2069",
    "data-name": "Grupo 2069"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_3990",
    "data-name": "Caminho 3990",
    d: "M238.662,336.966a14.939,14.939,0,0,0-23.51,18.018l-2.119,7.738,7.918-2.077a14.927,14.927,0,0,0,7.138,1.818h.006a14.938,14.938,0,0,0,10.566-25.5ZM228.1,359.941h0a12.4,12.4,0,0,1-6.319-1.73l-.453-.269-4.7,1.232,1.254-4.58-.3-.47a12.416,12.416,0,1,1,10.517,5.816Zm6.81-9.3c-.373-.187-2.208-1.089-2.55-1.214s-.591-.187-.84.187-.964,1.214-1.182,1.463-.435.28-.809.093a10.193,10.193,0,0,1-3-1.852,11.244,11.244,0,0,1-2.076-2.585c-.218-.374-.023-.575.164-.761.168-.167.373-.436.56-.654a2.553,2.553,0,0,0,.373-.622.687.687,0,0,0-.031-.654c-.093-.187-.84-2.023-1.151-2.77-.3-.728-.611-.629-.84-.641s-.467-.013-.715-.013a1.371,1.371,0,0,0-1,.467,4.184,4.184,0,0,0-1.306,3.113,7.256,7.256,0,0,0,1.524,3.86,16.635,16.635,0,0,0,6.376,5.634,21.422,21.422,0,0,0,2.128.786,5.116,5.116,0,0,0,2.351.148,3.844,3.844,0,0,0,2.519-1.774,3.12,3.12,0,0,0,.218-1.774C235.528,350.926,235.279,350.832,234.906,350.645Z",
    transform: "translate(-213.033 -332.587)",
    fill: "#3ebf17"
  })))))));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgIconWhatsapp, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/icon-whatsapp.a896ff84.svg";
export { ForwardRef as ReactComponent };